import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Stats from '../components/Stats';
import Modules from '../components/Modules';
import WhyChoose from '../components/WhyChoose';
import Industries from '../components/Industries';
import AIComingSoon from '../components/AIComingSoon';
import MobileApp from '../components/MobileApp';
import CTA from '../components/CTA';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.fade-in').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <Stats />
      <Modules />
      <WhyChoose />
      <Industries />
      <AIComingSoon />
      <MobileApp />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;
